const appLicenceActionTypes = {
	SELECT_APP_COMPANY_DETAILS: "SELECT_APP_COMPANY_DETAILS",
};
export default appLicenceActionTypes;
